import {
  library,
  config,
} from '@fortawesome/fontawesome-svg-core'
import {
  faListUl,
  faEarthAfrica,
  faPaperPlane,
  faSquareExclamation,
  faCircleXmark,
} from '@fortawesome/pro-solid-svg-icons'

export default defineNuxtPlugin(() => {
  config.autoAddCss = false

  library.add({
    faListUl,
    faEarthAfrica,
    faPaperPlane,
    faSquareExclamation,
    faCircleXmark,
  })
})
